import { defineMessages } from 'react-intl';

export const giftCardCheckoutDeliveryMethodEmailMessages = defineMessages({
  recipientEmailFieldPlaceholder: {
    defaultMessage: 'Recipient email',
    description: 'Gift Card Checkout Form | Delivery Options | "Recipient email" field placeholder',
  },
});
